<template>
  <div>
    <div class="card dash-card ti_border_dark tiny card-2022-dark" >
      {{ $t('Webportal.DashboardBMW.KpiWithPoints') }}
    </div>
    <div class="card dash-card ti_border_dark_dashed tiny card-2022-dark-dashed" style="height: 43px;" >
      {{ $t('Webportal.DashboardBMW.KpiWithPointsLongText') }}
    </div>
  </div>
</template>

<script>

  export default {
    name: 'KpiWithPointsLegend'
  }

</script>

<style scoped>

.card-body-spacer {
  padding: 0px;
}
h3{
  font-size: 10pt;
  margin: 0pt;
  text-align: left;
  font-stretch: extra-condensed;
  white-space: normal;
  margin-top: 4px;
  font-weight: bold;
  margin-left: 0.75rem;
}
.tiny {
  line-height: 0.95rem;
  font-size: 10pt;
  text-align: center;
  margin-left: 0.75rem;
}

</style>
